module.exports = __webpack_public_path__ + "assets/cpws.1dc4420f.svg";